<template>

    <nav class="navbar navbar-custom navbar-expand-lg fixed-top">
        <div class="container-fluid">
            <router-link class="navbar-brand" to="/">
                <img id="nav-logo" :src="logoUse" alt="logo" width="120" height="40">
            </router-link>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent" v-if="showMainNav">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item dropdown" v-if="$store.state.isAuthenticated">
                        <a class="nav-link dropdown-toggle" href="#" id="nav_drop_down_1" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {{ $t('inventory_manage') }}
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="nav_drop_down_1" v-if="showNav" @click="closeDropDown(this)">
                            <li><router-link class="dropdown-item" to="/inventory">{{ $t('inventory_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/inventory/dn-list">{{ $t('inventory_delivery_list') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/inventory/stock-in">{{ $t('inventory_stock_in') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/inventory/stock-out">{{ $t('inventory_stock_out') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/inventory/stock-out-temp">{{ $t('inventory_stock_out_temp') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/inventory/transfer-in">{{ $t('inventory_stock_transfer_in') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/inventory/transfer-out">{{ $t('inventory_stock_transfer_out') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/inventory/write-off">{{ $t('inventory_stock_write_off') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/inventory/import">{{ $t('inventory_stock_excel_upload') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/inventory/log">{{ $t('inventory_log') }}</router-link></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown" v-if="$store.state.isAuthenticated">
                        <a class="nav-link dropdown-toggle" href="#" id="nav_drop_down_2" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {{ $t('product_manage') }}
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="nav_drop_down_2" v-if="showNav" @click="closeDropDown(this)">
                            <li><router-link class="dropdown-item" to="/product">{{ $t('product_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/product/min-stock-lv">{{ $t('product_min_stock_manage') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/product/upload">{{ $t('product_upload') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/product/images">{{ $t('product_multi_upload_img') }}</router-link></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown" v-if="$store.state.isAuthenticated">
                        <a class="nav-link dropdown-toggle" href="#" id="nav_drop_down_3" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {{ $t('stock_take_manage') }}
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="nav_drop_down_3" v-if="showNav" @click="closeDropDown(this)">
                            <li><router-link class="dropdown-item" to="/stock-take">{{ $t('stock_take_main_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/stock-take/log">{{ $t('stock_take_log') }}</router-link></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown" v-if="$store.state.isAuthenticated">
                        <a class="nav-link dropdown-toggle" href="#" id="nav_drop_down_4" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {{ $t('other_detail_manage') }}
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="nav_drop_down_4" v-if="showNav" @click="closeDropDown(this)">
                            <li><router-link class="dropdown-item" to="/other-details/location">{{ $t('location_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/other-details/main/mainCat">{{ $t('main_cat_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/other-details/category">{{ $t('category_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/other-details/brand">{{ $t('brand_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/other-details/size">{{ $t('size_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/other-details/main/sizedetail">{{ $t('size_details_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/other-details/color">{{ $t('color_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/other-details/material">{{ $t('material_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/other-details/unit">{{ $t('unit_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/other-details/department">{{ $t('department_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/other-details/driver">{{ $t('driver_table') }}</router-link></li>
<!--                            <li><router-link class="dropdown-item" to="/demo1" v-if="$is_demo === 't'">Demo: Drag and Drop</router-link></li>-->
                        </ul>
                    </li>
                    <li class="nav-item dropdown" v-if="$store.state.isAuthenticated">
                        <a class="nav-link dropdown-toggle" href="#" id="nav_drop_down_5" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {{ $t('system_manage') }}
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="nav_drop_down_5" v-if="showNav" @click="closeDropDown(this)">
                            <li><router-link class="dropdown-item" to="/system/online">{{ $t('now_online_user_table') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/system/user">{{ $t('user_manage') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/system/licence">{{ $t('license') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/system/auto">{{ $t('auto_logout_timer') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/system/log">{{ $t('system_log') }}</router-link></li>
                            <li><router-link class="dropdown-item" to="/system/change-pw">{{ $t('change_pw') }}</router-link></li>
                        </ul>
                    </li>

                    <li class="nav-item" v-if="$store.state.isAuthenticated">
                        <router-link class="nav-link" to="/" @click="logout">{{ $store.state.userShowName }}, {{ $t('logout') }}</router-link>
                    </li>
                </ul>

                <form class="d-flex">
                    <!--                    Here is the i18n lang-changer -->
                    <!--                    <li class="nav-item">-->
                    <!--                        <select class="lang-changer" v-model="$i18n.locales">-->
                    <!--                            <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">-->
                    <!--                                {{ lang }}-->
                    <!--                            </option>-->
                    <!--                        </select>-->
                    <!--                    </li>-->
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0" style="padding-right: 10px">
                        <li class="nav-item">
                            <a class="nav-link" href="#" @click="changeLan">{{ nextLan }}</a>
                        </li>
                    </ul>
                </form>
            </div>
        </div>
    </nav>

</template>

<script>
import logo from '@/assets/iconImage.jpg'

export default {
    name: "NavBar",
    data (){
        return{
            // Logo
            logoUse: logo,

            // Next Language to show
            nextLan: '',

            // Navbar dropdown list hide or show
            showNav: true,
            showMainNav: true,
        }
    },
    async mounted(){
        if (this.$i18n.locale === 'en') {
            this.nextLan = '中'
        }else{
            this.nextLan = 'Eng'
        }
    },
    methods: {
        // Change language by i18n
        changeLan(){
            this.$store.commit('setLanguage')
            this.$i18n.locale = this.$store.state.language
            this.$mainApi.defaults.headers.common['Accept-Language'] = this.$store.state.language
            if (this.$i18n.locale === 'en') {
                this.nextLan = '中'
            }else{
                this.nextLan = 'Eng'
            }
        },

        // navbar dropdown list close
        closeDropDown(){
            this.showMainNav = false
            this.showNav = false
            setTimeout(() => this.showNav = true, 1);
            setTimeout(() => this.showMainNav = true, 1);
        },

        async logout(){
            await this.$mainApi.post('api/client/logout/', {
                "user_id": this.$store.state.userServerID,
                "current_online_pk": this.$store.state.userOnlinePK,
                // Flag -> user, user manually logout
                "flag": "user"
            })
            .then(response => {
                delete this.$mainApi.defaults.headers.common["GL-User-ID"];
                delete this.$mainApi.defaults.headers.common["GL-User-Online-ID"];
                delete this.$mainApi.defaults.headers.common["GL-Page-ID"];
                delete this.$mainApi.defaults.headers.common["GL-Action-ID"];

                this.$store.commit('setUserLogout')
                this.$router.push('/login')
                this.closeDropDown()
            })
        }
    }
}
</script>

<style scoped lang="scss">

/* Modify the background color */
.navbar-custom {
    background-color: #bdbdbd;
}

nav{
    #lang-changer{
        white-space: nowrap;
    }
}

.dropdown:hover .dropdown-menu {
    display: block;
    margin-top: 0; // remove the gap so it doesn't close
}

a{
    color: #000000;
}


</style>
